import { useEffect, useState } from "react";
import { useProposals } from "../hooks/useProposals";
import { SiteFooter, SiteHeader } from "../components/SiteHeader";
import { Tile } from "../components/ProposalCards";
import { Empty, Loader } from "../components/Bits";
import { AreaChips, SearchForm, SortSeg, TopicSelect } from "../components/Filters";
import { useTopics } from "../hooks/useTopics";

export default function AllProposals() {
  const [area, setArea] = useState("");
  const [topic, setTopic] = useState("");
  const [sort, setSort] = useState("liked");
  const [q, setQ] = useState("");
  const [draft, setDraft] = useState("");
  const { items, loading } = useProposals({ sort, area, q, topic });
  const topicName = useTopics().find((t) => t.id === topic)?.name || "";

  useEffect(() => {
    document.title = "All proposals · ReimagineCork";
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }} data-testid="all-proposals-page">
      <SiteHeader />
      <main className="wrap" style={{ flex: 1, width: "100%", paddingTop: 48, paddingBottom: 96 }}>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "flex-end", gap: 20, marginBottom: 24 }}>
          <div>
            <p className="kicker">All proposals</p>
            <h1 className="head" style={{ fontSize: "clamp(34px, 4vw, 48px)", fontWeight: 800, letterSpacing: "-.03em", margin: 0 }}>Every idea for Cork, in one place</h1>
          </div>
          <SearchForm id="all" value={draft} onChange={setDraft} onSubmit={() => setQ(draft.trim())} />
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: 12, alignItems: "center", marginBottom: 28 }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
            <AreaChips area={area} onChange={setArea} />
            <TopicSelect topic={topic} onChange={setTopic} id="all-topic-filter" />
          </div>
          <SortSeg sort={sort} onChange={setSort} />
        </div>
        <p className="meta" role="status" style={{ marginBottom: 16 }} data-testid="all-results-count">
          {loading ? "Loading…" : `${items.length} proposal${items.length === 1 ? "" : "s"}`}{topicName && ` in ${topicName}`}{q && ` for “${q}”`}
        </p>
        {loading && !items.length ? <Loader /> : null}
        {!loading && !items.length && (
          <Empty title="No proposals match">
            Try another area, topic or search. <button type="button" className="btn-link" onClick={() => { setQ(""); setDraft(""); setArea(""); setTopic(""); }} data-testid="all-clear-filters-btn">Clear filters</button>
          </Empty>
        )}
        <ul style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 24, padding: 0, margin: 0 }}>
          {items.map((p) => <Tile key={p.id} p={p} />)}
        </ul>
      </main>
      <SiteFooter />
    </div>
  );
}
